import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Header from '../components/Header/Header';
import Footer from '../components/Footer/Footer';
import UserDetailsPage from './pages/Profile/UserDetailsPage';
import ChangePasswordPage from './pages/Profile/ChangePasswordPage';
import BookingHistoryPage from './pages/Profile/BookingHistoryPage';
import MyPassengersPage from './pages/Profile/MyPassengersPage';
import MessagesPage from './pages/Profile/MessagesPage';
import NotificationsPage from './pages/Profile/NotificationsPage';
import PaymentMethodsPage from './pages/Profile/PaymentMethodsPage';
import TravelPreferencesPage from './pages/Profile/TravelPreferencesPage';
import BookingDetailsPage from './pages/BookingDetails/BookingDetailsPage';
import CheckInPage from '../pages/CheckInPage/CheckInPage';
import BlogDetailPage from './pages/BlogDetailPage';
import BlogListPage from './pages/BlogListPage';

const JetSetterDashboard = () => {
  return (
    <div className="min-h-screen bg-jet-gray-100 pt-[70px] flex flex-col">
      <Header />
      <main className="flex-1">
        <Routes>
          {/* Default redirect to user details */}
          <Route path="/" element={<Navigate to="/jetsetter/profile/user-details" replace />} />
          
          {/* Profile Routes */}
          <Route path="/profile" element={<Navigate to="/jetsetter/profile/user-details" replace />} />
          <Route path="/profile/user-details" element={<UserDetailsPage />} />
          <Route path="/profile/change-password" element={<ChangePasswordPage />} />
          <Route path="/profile/booking-history" element={<BookingHistoryPage />} />
          <Route path="/profile/my-passengers" element={<MyPassengersPage />} />
          <Route path="/profile/messages" element={<MessagesPage />} />
          <Route path="/profile/notifications" element={<NotificationsPage />} />
          <Route path="/profile/payment-methods" element={<PaymentMethodsPage />} />
          <Route path="/profile/travel-preferences" element={<TravelPreferencesPage />} />
          
          {/* Booking Management Routes */}
          <Route path="/booking-details/:bookingToken" element={<BookingDetailsPage />} />
          <Route path="/checkin/:bookingId" element={<CheckInPage />} />
          
          {/* Blog Routes */}
          <Route path="/blogs" element={<BlogListPage />} />
          <Route path="/blog/:slug" element={<BlogDetailPage />} />
        </Routes>
      </main>
      <div className="pt-4 pb-[1.3rem] px-3 sm:px-5">
        <div className="rounded-[10px] border-b border-[rgba(167,180,201,0.2)] max-w-7xl mx-auto bg-white px-[5px]">
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default JetSetterDashboard;